import type { TipoOperacaoCreditoClienteCodigo } from "@/interface/extrato-credito-cliente";

export const ROTULO_POR_TIPO_OPERACAO_EXTRATO: Record<TipoOperacaoCreditoClienteCodigo, string> = {
  compra_creditos: "Compra de créditos",
  liberacao_creditos_pendente: "Liberação pendente",
  consumo_remessa: "Consumo (remessa)",
  estorno_cancelamento_remessa: "Estorno de remessa",
  estorno_cancelamento_venda_creditos: "Estorno de venda",
  ajuste_administrativo: "Ajuste administrativo",
};

export const OPCOES_TIPO_OPERACAO_EXTRATO: Array<{
  valor: TipoOperacaoCreditoClienteCodigo;
  rotulo: string;
}> = (
  Object.entries(ROTULO_POR_TIPO_OPERACAO_EXTRATO) as Array<
    [TipoOperacaoCreditoClienteCodigo, string]
  >
).map(([valor, rotulo]) => ({ valor, rotulo }));
